__turbopack_context__.v({
  "className": "mbEAca_className",
  "variable": "mbEAca_variable",
});
